import { render } from "./MentionsSante.vue?vue&type=template&id=123cdb34&scoped=true"
import script from "./MentionsSante.vue?vue&type=script&lang=js"
export * from "./MentionsSante.vue?vue&type=script&lang=js"

import "./MentionsSante.vue?vue&type=style&index=0&id=123cdb34&lang=scss&scoped=true"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123cdb34"]])

export default __exports__